var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 3.66667L10.0883 11.7617C10.0385 12.4594 9.45786 13 8.75834 13H3.24133C2.54181 13 1.96122 12.4594 1.91138 11.7617L1.33317 3.66667M4.6665 6.33333V10.3333M7.33317 6.33333V10.3333M7.99984 3.66667V1.66667C7.99984 1.29848 7.70136 1 7.33317 1H4.6665C4.29831 1 3.99984 1.29848 3.99984 1.66667V3.66667M0.666504 3.66667H11.3332",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.d9c5ccdd.svg";
export { ForwardRef as ReactComponent };